import React from "react";
import { observer } from "mobx-react";
import { ReportTypeUpdateStore } from "../../store";
import { ReportTypeUpdateForm } from "./ReportTypeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type ReportTypeUpdateProps = {
  reportTypeUpdateStore: ReportTypeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ReportTypeUpdate: React.FC<ReportTypeUpdateProps> = observer(
  ({ reportTypeUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={reportTypeUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={reportTypeUpdateStore.savedButOutdated}
          onReload={() => reportTypeUpdateStore.reloadReportType()}
          reloadDisabled={reportTypeUpdateStore.isProcessing}
        />
        <ReportTypeUpdateForm
          reportTypeUpdateStore={reportTypeUpdateStore}
          nameError={reportTypeUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            reportTypeUpdateStore.setNameValue(value);
          }}
          name={reportTypeUpdateStore.entityValues.name}
          descriptionError={reportTypeUpdateStore.errors.description?.message}
          onDescriptionChange={(value: string) => {
            reportTypeUpdateStore.setDescriptionValue(value);
          }}
          description={reportTypeUpdateStore.entityValues.description}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={reportTypeUpdateStore.saveDisabled}
          onSave={() => reportTypeUpdateStore.saveReportType()}
          onCancel={() => reportTypeUpdateStore.cancelReportType()}
        />
        <ErrorDialog
          open={reportTypeUpdateStore.errorDialogOpened}
          title={reportTypeUpdateStore.errorTitle}
          description={reportTypeUpdateStore.errorDescription}
          onClose={() => reportTypeUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={reportTypeUpdateStore.confirmDialogOpened}
          title={reportTypeUpdateStore.confirmDialogTitle}
          description={reportTypeUpdateStore.confirmDialogDescription}
          onConfirm={() => reportTypeUpdateStore.executeConfirmedAction()}
          onCancel={() => reportTypeUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
